import { lazy } from 'react';
import { AUDIT_PERMISSIONS } from './constants';

const AuditPage = lazy(() => import('./pages/AuditPage'));

export const auditRoutes = [
  {
    path: '/audit',
    element: AuditPage,
    permission: AUDIT_PERMISSIONS.READ,
    // Activity / audit log hidden from sidebar navigation
    nav: null,
  },
];
